import { NgModule } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResizableModule } from 'angular-resizable-element';
import { DragAndDropModule } from 'angular-draggable-droppable';
import { CalendarWeekViewComponent } from './calendar-week-view.component';
import { CalendarWeekViewHeaderComponent } from './calendar-week-view-header.component';
import { CalendarWeekViewEventComponent } from './calendar-week-view-event.component';
import { CalendarCommonModule } from '../common/calendar-common.module';
import { toArray } from 'rxjs/operators';


import { CalendarCustomWeekViewComponent } from './calendar-custom-week-view.component';

export {
  CalendarWeekViewComponent,
  CalendarWeekViewBeforeRenderEvent
} from './calendar-week-view.component';

export {
  WeekViewEvent as CalendarWeekViewEvent,
  WeekViewEventRow as CalendarWeekViewEventRow,
  GetWeekViewArgs as CalendarGetWeekViewArgs
} from 'calendar-utils';


export { CalendarCustomWeekViewComponent } from './calendar-custom-week-view.component';


function getDateSec(date) {
  let _date = new Date(date);
  _date.setHours(0, 0, 0, 0);
  return _date.getTime();
}

function deepClone(obj) {
  var visitedNodes = [];
  var clonedCopy = [];
  function clone(item) {
      if (typeof item === "object" && !Array.isArray(item)) {
          if (visitedNodes.indexOf(item) === -1) {
              visitedNodes.push(item);
              var cloneObject = {};
              clonedCopy.push(cloneObject);
              for (var i in item) {
                  if (item.hasOwnProperty(i)) {
                      cloneObject[i] = clone(item[i]);
                  }
              }
              return cloneObject;
          } else {
              return clonedCopy[visitedNodes.indexOf(item)];
          }
      }
      else if (typeof item === "object" && Array.isArray(item)) {
          if (visitedNodes.indexOf(item) === -1) {
              var cloneArray = [];
              visitedNodes.push(item);
              clonedCopy.push(cloneArray);
              for (var j = 0; j < item.length; j++) {
                  cloneArray.push(clone(item[j]));
              }
              return cloneArray;
          } else {
              return clonedCopy[visitedNodes.indexOf(item)];
          }
      }

      return item; // not object, not array, therefore primitive
  }
  return clone(obj);
}

const colors: any = {
  red: {
    primary: '#b94a48',
    secondary: '#b94a48'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  },
  green: {
    primary: '#07aa09',
    secondary: '#07aa09'
  }
};


@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
  transform(value, args: string[]): any {
    let values = [];
    for (let key in value) {
      console.log(value);
      values.push(value[key]);
    }
    return values;
  }
}

@Pipe({
  name: 'userFilters'
})

export class UserFiltersPipe implements PipeTransform {
  transform(events: any[], days: any[]): any {
    let userEvents = {};
    let results = [];
    let count = 0;
    let _userEvents = [];

    console.log(events);

    if (events && events.length > 0) {
      events.forEach(event => {
        if (event['row'] && event['row'].length > 0) {
          event['row'].forEach(ev => {
            // clean up swap requests--they're bad juju
            if (ev.event.provider_schedules && ev.event.provider_schedules.length > 0) {
              ev.event.provider_schedules = ev.event.provider_schedules.map(sch => {
                let schClean = Object.assign({}, sch);
                delete schClean.swap_request;
                return schClean;
              });
            }

            if (ev.event.doctors && ev.event.doctors.length > 0) {
              ev.event.doctors.forEach(function (doc) {
                if (!userEvents[doc.id]) userEvents[doc.id] = [];
                let _ev = JSON.parse(JSON.stringify(ev));
                _ev['provider'] = doc;
                userEvents[doc.id].push(_ev);
              });
            }
          });
        }
      });
    };

    if (Object.keys(userEvents).length > 0) {
      for (let i in userEvents) {
        let _ev = JSON.parse(JSON.stringify(userEvents[i]));

        if (days && days.length > 0) {
          days.forEach(function (day) {
            let evs = _ev.filter(function (_ev1) {
              return getDateSec(_ev1.event.start) === getDateSec(day.date);
            });

            if (evs.length === 0) {
              let _ev12 = JSON.parse(JSON.stringify(_ev[0]));
              _ev12['event']['title'] = "Not Working";
              _ev12['event']['start'] = day.date;
              _ev12['event']['end'] = day.date;
              _ev12['event']['color'] = {
                primary: '#777',//'#e3bc08',
                secondary: '#ccc',//'#FDF1BA'
              };
              _ev12['offset'] = day.date.getDay();
              _ev.push(_ev12);
            }
          });
        }
        results.push(_ev);
      }
    }
    console.log('results', results);
    
    return results;
  }
}

@Pipe({
  name: 'shiftFilters'
})
export class ShiftFiltersPipe implements PipeTransform {
  transform(eventsSchedules: any[], schedules: any[], days: any[], showEmptyShifts: boolean = false): any {
    
    let shiftEvents = {};
    let results = [];
    

    let eventsScheduleArr = [];
    if (eventsSchedules && eventsSchedules.length>0){
      eventsSchedules.forEach(function (eventsShiftSchedule) {
        if(eventsShiftSchedule.row && eventsShiftSchedule.row.length>0){
          eventsShiftSchedule.row.forEach(shift => {
            eventsScheduleArr.push(shift);
          });
        }
      });
    }

    if (schedules && schedules.length > 0){
      schedules.forEach(function (schedule){
        let daysEvents = [];
        days.forEach(function(day){

          let existShift = eventsScheduleArr.filter(evShift => {
            let date1 = new Date(day.date.getFullYear(),day.date.getMonth(),day.date.getDate());
            let date2 = new Date(evShift.event.start.getFullYear(),evShift.event.start.getMonth(),evShift.event.start.getDate());
            return  date1.getTime() ==  date2.getTime() && schedule.name === evShift.event.schedule;
          });
          //console.log('existShift.length',existShift.length);
          
          if(existShift.length>0){
            let event = deepClone(existShift[0].event);
            //console.log(event.provider_schedules);
            event['doctor'] = event['doctors'][0];
            event['color'] = (event['doctor']) ? colors.green : colors.red;
            if (event.provider_schedules && event.provider_schedules !== "undefined"){
              if (event.provider_schedules[0].swap_request && event.provider_schedules[0].swap_request !== "undefined"){
                if (event.provider_schedules[0].swap_request.id && event.provider_schedules[0].swap_request.id !== "undefined"){
                  event['color'] = colors.yellow;
                }
              }
            }
            event['title'] = (event['doctor']) ? event['title'] : 'No doctors assigned';

            let dayEvent = {
              event: event,
              offset: day.date.getDay(),
              span: 1,
              startsBeforeWeek: false,
              endsAfterWeek: false
            }
            daysEvents.push(dayEvent);
          }else{
            let dayEvent = {
              event: {
                schedule: schedule.name,
                title: "No Shift",
                start: day.date,
                end: day.date,
                color: {
                  primary: '#777',
                  secondary: '#ccc'
                },
                resizable: {
                  "beforeStart": true,
                  "afterEnd": true
                },
                draggable: false,
              },
              offset: day.date.getDay(),
              span: 1,
              startsBeforeWeek: false,
              endsAfterWeek: false
            }
            daysEvents.push(dayEvent);
          }
        });
        results.push([daysEvents]);
      });
    }

    // one more quick filter to remove rows with no shifts
    if (!showEmptyShifts) {
      results = results.filter(shift => {
        return (0 < shift[0].filter(ev => ev.event.doctor || ev.event.doctors).length);
      })
    }

    console.log(results);
    return results;
  }
}

@NgModule({
  imports: [
    CommonModule,
    ResizableModule,
    DragAndDropModule,
    CalendarCommonModule
  ],
  declarations: [
    CalendarWeekViewComponent,
    CalendarWeekViewHeaderComponent,
    CalendarWeekViewEventComponent,
    UserFiltersPipe,
    KeysPipe,
    ShiftFiltersPipe,
    CalendarCustomWeekViewComponent
  ],
  exports: [
    ResizableModule,
    DragAndDropModule,
    CalendarWeekViewComponent,
    CalendarWeekViewHeaderComponent,
    CalendarWeekViewEventComponent,
    UserFiltersPipe,
    KeysPipe,
    ShiftFiltersPipe,
    CalendarCustomWeekViewComponent
  ]
})
export class CalendarWeekModule { }



// WEBPACK FOOTER //
// ./src/app/modules/calendar/week/calendar-week.module.ts